import React from 'react';
import { Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import BarChartIcon from '@mui/icons-material/BarChart';
import { useNavigate } from 'react-router-dom';
import { canAccessStatistics } from '../config/roleAccess';

function LogbookQuickActions({ user, compact = false, stopPropagation = false }) {
  const navigate = useNavigate();
  const showStatistik = canAccessStatistics(user);

  const handleNavigate = (event, path) => {
    if (stopPropagation && event) {
      event.preventDefault();
      event.stopPropagation();
    }
    navigate(path);
  };

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} sx={{ width: '100%' }}>
      <Button
        variant="contained"
        color="primary"
        size={compact ? 'small' : 'medium'}
        startIcon={<AddIcon />}
        onClick={(event) => handleNavigate(event, '/eintrag-vornehmen')}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          minHeight: { xs: 44, sm: 'auto' },
        }}
      >
        Eintrag hinzufügen
      </Button>

      {showStatistik && (
        <Button
          variant="outlined"
          color="success"
          size={compact ? 'small' : 'medium'}
          startIcon={<BarChartIcon />}
          onClick={(event) => handleNavigate(event, '/statistik')}
          sx={{
            width: { xs: '100%', sm: 'auto' },
            minHeight: { xs: 44, sm: 'auto' },
          }}
        >
          Statistik
        </Button>
      )}
    </Stack>
  );
}

export default LogbookQuickActions;
